module.exports = __webpack_public_path__ + "static/media/ctbc-3-wireframe.6b15a412.png";